import theme from '../../../lib/theme';
import { ValuePropositionsProps } from './ValuePropositions';

const { media, scale, colors } = theme;

export default ({
  isV2Collection
}: ValuePropositionsProps) => ({
  container: {
    borderTop: isV2Collection ? 'none' : `1px solid ${colors.grey}`,
    borderBottom: isV2Collection ? 'none' : `1px solid ${colors.grey}`,
    padding: `${isV2Collection ? 0 : scale.m} ${scale.xs} ${isV2Collection ? 0 : scale.m}`,

    [media.s.up]: {
      margin: `${isV2Collection ? 0 : scale.s} 0 ${isV2Collection ? 0 : scale.s}`,
    },

    [media.xl.up]: {
      margin: `${isV2Collection ? 0 : scale.m} 0 ${isV2Collection ? 0 : scale.m}`,
    },
  },
  innerContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '1160px',
    alignItems: 'center',
    justifyContent: 'space-between',

    [media.m.up]: {
      flexDirection: 'row',
      alignItems: 'stretch',
    },
  },
  valueProposition: {
    textAlign: 'center',
    padding: `${scale.s} 0`,

    [media.m.up]: {
      padding: `${scale.l} 0`,

      '~ div': {
        padding: `${scale.l} 0 ${scale.l} ${scale.xs}`,
      },
    },
    img: {
      width: '75%',
      maxWidth: '180px',
    },
  },
});
